import { GroupFormView } from "@/modules/dynamic-attributes/entities/group";
import { DynamicAttributeEntity, EntityGroupFragment } from "gql/graphql";
import { extractLocalizedValue } from "@/shared/form/localized-value/utils/extract-localized-value";
import { useSaveDynamicAttributeGroup } from "@/modules/dynamic-attributes/feature/save-dynamic-attribute-group/model/use-save-dynamic-attribute-group";
import { FieldsType } from "./model/types";

export function SaveDynamicAttributeGroup({
  afterSubmit,
  entity,
  group,
}: {
  afterSubmit?: () => void;
  entity: DynamicAttributeEntity;
  group?: EntityGroupFragment;
}) {
  const { save } = useSaveDynamicAttributeGroup({
    afterSubmit,
  });

  return (
    <GroupFormView
      onFinish={save}
      initialValues={
        {
          ...transform(entity, group),
        } as FieldsType
      }
    />
  );
}

function transform(
  entity: DynamicAttributeEntity,
  group?: EntityGroupFragment,
) {
  return {
    id: group?.id,
    name: extractLocalizedValue(group?.name),
    order: group?.order,
    dynamicAttributeEntity: entity,
  };
}
